"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoteTriangleIcon = exports.VoteCountInner = exports.TopicVoteCountWrapper = exports.TopicVoteButton = exports.TopicLikeButton = exports.FeaturedTopicVoteButton = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Triangle = _interopRequireDefault(require("@insided/destination/icons/Triangle"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _excluded = ["className", "size", "children", "hasVoted"],
    _excluded2 = ["className", "size", "children", "hasVoted"],
    _excluded3 = ["className", "votes", "hasVoted"];

var TopicVoteCountWrapper = function TopicVoteCountWrapper(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("span", {
    className: "topic__likes-count"
  }, (0, _preact.h)("i", {
    role: "presentation",
    className: (0, _classnames.default)('thread-meta-item__icon', 'icon--auto-width', 'icon--thumb-up')
  }), children);
};

exports.TopicVoteCountWrapper = TopicVoteCountWrapper;

var TopicVoteButton = function TopicVoteButton(_ref2) {
  var className = _ref2.className,
      size = _ref2.size,
      children = _ref2.children,
      hasVoted = _ref2.hasVoted,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.vote",
    renderAsText: true
  }, function (accessibilityLabelVote) {
    return (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.retract_vote",
      renderAsText: true
    }, function (accessibilityLabelRetractVote) {
      return (0, _preact.h)("button", (0, _extends2.default)({
        "aria-label": hasVoted ? accessibilityLabelRetractVote : accessibilityLabelVote,
        type: "button",
        className: (0, _classnames.default)('qa-topic-meta-likes-icon', 'thread-meta-item', className, {
          preact_voted: hasVoted,
          'btn--toggle': true,
          'thread-meta-item--vote': size !== 'small',
          'btn--toggle-small': size === 'small',
          'thread-meta-item--vote-small': size === 'small'
        })
      }, buttonProps), children);
    });
  });
};

exports.TopicVoteButton = TopicVoteButton;

var TopicLikeButton = function TopicLikeButton(_ref3) {
  var className = _ref3.className,
      size = _ref3.size,
      children = _ref3.children,
      hasVoted = _ref3.hasVoted,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref3, _excluded2);
  return (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.like",
    renderAsText: true
  }, function (accessibilityLabelLike) {
    return (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.retract_like",
      renderAsText: true
    }, function (accessibilityLabelRetractLike) {
      return (0, _preact.h)("button", (0, _extends2.default)({
        "aria-label": hasVoted ? accessibilityLabelRetractLike : accessibilityLabelLike,
        type: "button",
        className: (0, _classnames.default)('qa-topic-meta-likes-icon', 'thread-meta-item', className, {
          // like behavior
          'thread-meta-item--likes--liked': hasVoted,
          'thread-meta-item--hover-highlight': true,
          'thread-meta-item--likes': true
        })
      }, buttonProps), children);
    });
  });
};

exports.TopicLikeButton = TopicLikeButton;

var VoteTriangleIcon = function VoteTriangleIcon(_ref4) {
  var className = _ref4.className,
      size = _ref4.size;
  return (0, _preact.h)(_Triangle.default, {
    role: "presentation",
    width: size === 'small' ? 8 : 10,
    height: size === 'small' ? 6 : 8,
    className: className
  });
};

exports.VoteTriangleIcon = VoteTriangleIcon;

var FeaturedTopicVoteButton = function FeaturedTopicVoteButton(_ref5) {
  var className = _ref5.className,
      votes = _ref5.votes,
      hasVoted = _ref5.hasVoted,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref5, _excluded3);
  return (0, _preact.h)(_phrase.default, {
    p: "accessibility_label.vote",
    renderAsText: true
  }, function (accessibilityLabelVote) {
    return (0, _preact.h)(_phrase.default, {
      p: "accessibility_label.retract_vote",
      renderAsText: true
    }, function (accessibilityLabelRetractVote) {
      return (0, _preact.h)("button", (0, _extends2.default)({
        "aria-label": hasVoted ? accessibilityLabelRetractVote : accessibilityLabelVote,
        type: "button",
        className: (0, _classnames.default)('featured-topic__vote', {
          'featured-topic__vote--voted': hasVoted
        })
      }, buttonProps), (0, _preact.h)("span", {
        className: "featured-topic__voteAmount"
      }, votes), (0, _preact.h)(VoteTriangleIcon, {
        className: "featured-topic__voteIcon"
      }));
    });
  });
};

exports.FeaturedTopicVoteButton = FeaturedTopicVoteButton;

var VoteCountInner = function VoteCountInner(_ref6) {
  var count = _ref6.count,
      _ref6$showText = _ref6.showText,
      showText = _ref6$showText === void 0 ? false : _ref6$showText,
      className = _ref6.className;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)(className, 'js-vote-count', 'qa-topic-meta-likes-content')
  }, showText ? (0, _preact.h)(_phrase.default, {
    p: "upvote"
  }) : '', " ", count);
};

exports.VoteCountInner = VoteCountInner;